var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridViewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1712 3.17578H14.9693C14.8104 3.17578 14.6815 3.047 14.6815 2.88804V0.78726C14.6815 0.629153 14.8104 0.499945 14.9693 0.499945H19.1712C19.3303 0.499945 19.459 0.628904 19.459 0.78726V2.88804C19.459 3.047 19.3301 3.17578 19.1712 3.17578Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1712 7.90332H14.9693C14.8102 7.90332 14.6815 7.77436 14.6815 7.61601V5.51522C14.6815 5.35627 14.8104 5.22748 14.9693 5.22748H19.1712C19.3301 5.22748 19.459 5.35627 19.459 5.51522V7.61601C19.459 7.77411 19.3301 7.90332 19.1712 7.90332Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1712 12.6309H14.9693C14.8106 12.6309 14.6815 12.5018 14.6815 12.3431V10.2423C14.6815 10.0836 14.8106 9.9546 14.9693 9.9546H19.1712C19.3301 9.9546 19.459 10.0834 19.459 10.2423V12.3431C19.459 12.5021 19.3301 12.6309 19.1712 12.6309Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59143 2.88902V2.88804V0.78726C7.59143 0.628978 7.72046 0.499945 7.87875 0.499945H12.0812C12.2402 0.499945 12.3689 0.628904 12.3689 0.78726V2.88804C12.3689 3.047 12.24 3.17578 12.0812 3.17578H7.87875C7.71882 3.17578 7.59112 3.04702 7.59143 2.88902Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59143 7.61698V7.61601V5.51522C7.59143 5.35609 7.72046 5.22748 7.87875 5.22748H12.0812C12.24 5.22748 12.3689 5.35627 12.3689 5.51522V7.61601C12.3689 7.77411 12.24 7.90332 12.0812 7.90332H7.87875C7.71865 7.90332 7.59112 7.77439 7.59143 7.61698Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98985 3.17578H0.787862C0.62898 3.17578 0.500123 3.047 0.500123 2.88804V0.78726C0.500123 0.629153 0.62898 0.499945 0.787862 0.499945H4.98985C5.14866 0.499945 5.27759 0.629079 5.27759 0.78726V2.88804C5.27759 3.04682 5.14848 3.17578 4.98985 3.17578Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98985 7.90332H0.787862C0.628804 7.90332 0.500123 7.77436 0.500123 7.61601V5.51522C0.500123 5.35627 0.62898 5.22748 0.787862 5.22748H4.98985C5.14848 5.22748 5.27759 5.35644 5.27759 5.51522V7.61601C5.27759 7.77394 5.14848 7.90332 4.98985 7.90332Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98985 12.6309H0.787862C0.629156 12.6309 0.500123 12.5018 0.500123 12.3431V10.2423C0.500123 10.0836 0.629155 9.9546 0.787862 9.9546H4.98985C5.14848 9.9546 5.27759 10.0836 5.27759 10.2423V12.3431C5.27759 12.5019 5.14848 12.6309 4.98985 12.6309Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98985 17.3574H0.787862C0.62898 17.3574 0.500123 17.2286 0.500123 17.0697V14.9689C0.500123 14.8099 0.62898 14.6812 0.787862 14.6812H4.98985C5.14848 14.6812 5.27759 14.8101 5.27759 14.9689V17.0697C5.27759 17.2282 5.14831 17.3574 4.98985 17.3574Z",
    fill: "#1B3E61",
    stroke: "#1B3E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewActive);
export default __webpack_public_path__ + "static/media/grid-view-active.1b34b30c450945d3c581fb404b434e56.svg";
export { ForwardRef as ReactComponent };